import { createContext } from "react";
import { Profile, Connected } from "../types";
import { History } from "history";
import { logout } from "../actions";

export type LayoutContextProps = {
	authenticated: boolean;
	history: History;
	logout: Connected<typeof logout>;
	profile: Profile;
	newVersionAvailable: boolean;
	bodyClass: string;
};

const LayoutContext = createContext({} as LayoutContextProps);

export default LayoutContext;
